<div class="warning-dialog-container">
  <img [hidden]="data.hideImage" [src]="data.image" />
  @if (data.header) {
    <h3 class="header">{{ data.header | translate }}</h3>
  }
  <p class="message">{{ data.message | translate }}</p>
  <div class="action-btns m-4">
    <button
      mat-stroked-button
      color="primary"
      (click)="cancel()"
      appTrackClick="warning-dialog-cancel-btn"
    >
      {{ data.cancelBtnLabel | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="proceed()"
      appTrackClick="warning-dialog-proceed-btn"
      ctaType="primary"
    >
      {{ data.proceedBtnLabel | translate }}
    </button>
  </div>
</div>
